import { fetchContactsData,fetchMessage } from "./actions/fetchAction";
import { ContactsReducer, ContactReducer } from "./reducers/fetchReducers"; 

const contactsReducers = {
  contactsGloalStore: ContactsReducer,
  contactStore: ContactReducer
}

export {fetchContactsData, fetchMessage, contactsReducers};
